// Scroll
var scroll_p;
var windowHeight_p = $(window).height();

$(window).scroll(function(){
  scroll_p = $(window).scrollTop();

  $('.fwt_img').each(function(){
    var objectPosition = $(this).offset().top;
    if(scroll_p > objectPosition - windowHeight_p + 300){
      $(this).addClass("fwt_img_A");
    }
  });
  
});


$(".inview").on("inview", function (event, isInView) {
  if (isInView) {
   $(this).stop().addClass("is-show");
  }
});




document.querySelectorAll(".remove-dot").forEach((p) => {
  p.innerHTML = p.innerHTML.replace(/・/g, ""); // クラスが「remove-dot」の要素内の「・」を非表示にする
});   

document.addEventListener("DOMContentLoaded", function() {
  // 特定のクラスを持つ<p>要素を取得
  const paragraph = document.querySelector(".remove-dot");

  // <p>要素が存在する場合のみ処理を実行
  if (paragraph) {
    // <p>要素の内容を<br>ごとに分割して配列に変換
    const items = paragraph.innerHTML.split("<br>");

    // <ul>要素を作成
    const ul = document.createElement("ul");
    ul.classList.add("remove-dot-list"); // ここでクラスを追加

    // 各行に<li>を作成して<ul>に追加
    items.forEach(item => {
      const li = document.createElement("li");
      li.textContent = item.trim(); // 各項目の先頭や末尾の余白を削除
      ul.appendChild(li);
    });

    // 元の<p>要素を<ul>で置き換える
    paragraph.replaceWith(ul);
  }
});


// すべての色バッジを取得
const colorSwatches = document.querySelectorAll('.color-swatch');

// 各色バッジにクリックイベントを追加
colorSwatches.forEach(swatch => {
  swatch.addEventListener('click', function () {
    
    // データ属性から画像URLと商品IDを取得
    const baseImageUrl = this.getAttribute('data-image'); // 画像URL
    const newImageUrl = baseImageUrl.replace('_medium', '');
    const productId = this.getAttribute('data-product-id'); // 商品ID

    // 対応する商品画像を取得
    const productImage = document.querySelector(`#main-image-${productId}`);

    if (productImage) {
      // 画像のsrcとsrcsetを更新
      productImage.src = newImageUrl;
      productImage.srcset = ''; // srcsetをクリアして干渉を防ぐ

      // アクティブなバッジのスタイルを更新
      document.querySelectorAll(`.color-swatch[data-product-id="${productId}"]`).forEach(swatch => {
        swatch.classList.remove('active');
      });
      this.classList.add('active');
      //console.log(`画像を変更しました: ${newImageUrl}`);
    }
  });
});

